export enum ShipmentRuleEntityTypeEnum {
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION'
}

export interface ShipmentRuleEntityType {
    id: ShipmentRuleEntityTypeEnum,
    name: ShipmentRuleEntityTypeEnum
}
